// Centralized contract addresses configuration
// This is the single source of truth for all contract addresses
// Reads from environment variables for centralized configuration management

export const CONTRACT_ADDRESSES = {
  // BSC Mainnet
  56: {
    sourceBridge: process.env.REACT_APP_BSC_SOURCE_BRIDGE,
    destBridge: process.env.REACT_APP_BSC_DEST_BRIDGE,
    verifier: process.env.REACT_APP_BSC_VERIFIER,
    usdt: process.env.REACT_APP_USDT_ADDRESS,
    rwaNova: process.env.REACT_APP_RWA_NOVA_BSC_ADDRESS || '0x49A756e34A5A0a7FDBFCce73d10228ee2C85CA8b'
  },
  // Xphere Mainnet
  20250217: {
    sourceBridge: process.env.REACT_APP_XPHERE_SOURCE_BRIDGE,
    destBridge: process.env.REACT_APP_XPHERE_DEST_BRIDGE,
    verifier: process.env.REACT_APP_XPHERE_VERIFIER,
    usdx: process.env.REACT_APP_USDX_ADDRESS,
    rwaNova: process.env.REACT_APP_RWA_NOVA_XPHERE_ADDRESS || '0x0DFfFad57Bc67701244B1bdA37E830eeadb0d69F'
  }
};

// Helper functions to get contract addresses
export const getContractAddress = (chainId, contractType) => {
  const chainContracts = CONTRACT_ADDRESSES[chainId];
  if (!chainContracts) {
    throw new Error(`No contracts found for chain ID: ${chainId}`);
  }
  
  const address = chainContracts[contractType];
  if (!address) {
    throw new Error(`Contract type '${contractType}' not found for chain ID: ${chainId}`);
  }
  
  return address;
};

export const getSourceBridgeAddress = (chainId) => getContractAddress(chainId, 'sourceBridge');
export const getDestBridgeAddress = (chainId) => getContractAddress(chainId, 'destBridge');
export const getTokenAddress = (chainId, tokenType) => getContractAddress(chainId, tokenType);

// Get all contracts for a chain
export const getChainContracts = (chainId) => {
  return CONTRACT_ADDRESSES[chainId] || null;
};

// Check if chain is supported
export const isChainSupported = (chainId) => {
  return chainId in CONTRACT_ADDRESSES;
};

// Get all supported chain IDs
export const getSupportedChainIds = () => {
  return Object.keys(CONTRACT_ADDRESSES).map(id => parseInt(id));
};
